export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13622.5d1a5d82.jpg";